import { Iframely as IFramely} from '@piconetworks/pkg-module-iframely'

import createDuck from '../baseDuck'

export default IFramely({
    createDuck,
})
